//
// Initial state objects for the StudyRecruitmentService Context/Providers
//

/**
 * To track the various loading states of API calls
 */
export const initLoading = {
  studyRecruitmentData: false,
  saveStudyRecruitmentData: false,
  studyRecruitmentMetrics: false,
  studies: false,
  outreachCohorts: false,
  updateOutreachCohortStatus: false,
};

/**
 * To track permissions for various actions on the StudyRecruitment.
 */
export const initUserPerms = {
  canViewStudyRecruitment: false,
  canEditStudyRecruitment: false,
}

export const initStudyRecruitmentData = {
  protocolId: "",
  protocolNumber: "",
  irbNumber: "",
  nctId: "",
  studyId: "",
  versions: [],
  lastOncoreSync: "",
  studyContacts: [],
  studyContactId: "",
  name: "",
  nameVisibility: false,
  email: "",
  emailVisibility: false,
  phone: "",
  phoneVisibility: false,
  versionId: "",
  officialStudyTitle: "",
  studyTitle: "",
  purpose: "",
  inclusionCriteria: "",
  exclusionCriteria: "",
  prescreeningQuestionnaireUrl: "",
  prescreeningQuestionnaireEstimatedTime: "",
};

export const initStudyRecruitmentMetrics = {
  oncoreStatus: "",
  targetAccrual: null,
  totalAccrual: null,
  percentAccrued: null,
  studyStatus: "",
  studyListingStatus: "",
  lastOncoreSync: "",
  outreachEnabled: false,
  schoolOfMedicineUrl: "",
  stanfordHealthCareUrl: "",
  pageViews: null,
  enrolledCountFromCt: null,
  isHonestBrokerWorkflowEnabled: false,
  isStudyTeamOutreachEnabled: false,
  totalOutreachCount: null,
  totalInterestedCount: null,
};

export const initOtherStudyContact = {
  mainPointOfContact: false,
  studyContactId: undefined,
  firstName: "Other",
  email: "",
  emailVisibility: false,
  phone: "",
  phoneVisibility: false,
};

export const initStudies = [];

export const initCohorts = [];
